__turbopack_context__.v({
  "galleryModalSwiper": "index-module-scss-module__pX2WpW__galleryModalSwiper",
});
